import { VenueOverrideSettingKey } from 'modules/shared-menu/types';

import { Offer, SharedMenuDietaryPreference, SharedMenuMandatoryWarning } from './types';
export const MENU_MOBILE_BREAKPOINT = 550;

export const PRODUCT_INFO_FIELD_MAX_LENGTH = 2000;

export const PRODUCT_INFO_EXTENDED_FIELD_MAX_LENGTH = 32000;

export const MORE_INFORMATION_FIELD_MAX_LENGTH = 5000;

export const INGREDIENTS_FIELD_MAX_LENGTH = 4000;

export const ITEM_MAX_IMAGE_COUNT = 5;

export const MAX_IMAGE_FILE_SIZE = 25 * 1000 * 1024; // 25MB

export const dietaryPreferenceTranslationMap: Record<SharedMenuDietaryPreference, string> = {
  gluten_free: 'menu.dietaryPreferences.glutenFree',
  lactose_free: 'menu.dietaryPreferences.lactoseFree',
  halal: 'menu.dietaryPreferences.halal',
  kosher: 'menu.dietaryPreferences.kosher',
  vegan: 'menu.dietaryPreferences.vegan',
  vegetarian: 'menu.dietaryPreferences.vegetarian',
};

export const sharedMenuMandatoryWarningsForCountry: Partial<Record<Country, SharedMenuMandatoryWarning[]>> = {
  ISR: [
    'with_alcohol_hard',
    'with_alcohol_soft',
    'choking_nuts',
    'choking_sausages',
    'medicine_otc',
    'with_fat',
    'with_sodium',
    'with_sugar',
  ],
};

export const sharedMenuMandatoryWarningTranslationMap: Record<SharedMenuMandatoryWarning, string> = {
  with_alcohol_hard: 'menu.mandatoryWarnings.withAlcoholHard',
  with_alcohol_soft: 'menu.mandatoryWarnings.withAlcoholSoft',
  choking_nuts: 'menu.mandatoryWarnings.chokingNuts',
  choking_sausages: 'menu.mandatoryWarnings.chokingSausages',
  medicine_otc: 'menu.mandatoryWarnings.medicineOtc',
  with_fat: 'menu.mandatoryWarnings.withFat',
  with_sodium: 'menu.mandatoryWarnings.withSodium',
  with_sugar: 'menu.mandatoryWarnings.withSugar',
};

export const mapOverrideSettingToOfferKeys: { [key in VenueOverrideSettingKey]: (keyof Offer)[] } = {
  venue_can_set_availability: ['enabled', 'weekly_availability', 'weekly_visibility'],
  venue_can_set_price: ['price', 'discounted'],
  venue_can_set_merchant_sku: ['merchant_sku'],
  venue_can_set_pos_id: ['external_id'],
};

export type OverridableRowGroup = 'AVAILABILITY' | 'PRICE_AND_DISCOUNT' | 'MERCHANT_SKU' | 'POS_ID' | 'VISIBILITY';

export const rowGroupToOfferAttrsMap: { [key in OverridableRowGroup]: (keyof Offer)[] } = {
  AVAILABILITY: ['enabled', 'weekly_availability'],
  PRICE_AND_DISCOUNT: ['price', 'discounted'],
  MERCHANT_SKU: ['merchant_sku'],
  POS_ID: ['external_id'],
  VISIBILITY: ['weekly_visibility'],
};

export const rowGroupToVenueOverrideSettingKeyMap: { [key in OverridableRowGroup]: VenueOverrideSettingKey } = {
  AVAILABILITY: 'venue_can_set_availability',
  PRICE_AND_DISCOUNT: 'venue_can_set_price',
  MERCHANT_SKU: 'venue_can_set_merchant_sku',
  POS_ID: 'venue_can_set_pos_id',
  VISIBILITY: 'venue_can_set_availability',
};

export const venueLevelOnlyAttrs: (keyof Offer)[] = ['inventory_mode'];
